"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readNumber = exports.parseNumberData = exports.ReadingConfig = exports.UnitNotEnoughError = exports.InvalidNumberError = void 0;
const types_1 = require("./types");
Object.defineProperty(exports, "InvalidNumberError", { enumerable: true, get: function () { return types_1.InvalidNumberError; } });
Object.defineProperty(exports, "UnitNotEnoughError", { enumerable: true, get: function () { return types_1.UnitNotEnoughError; } });
const ReadingConfig_1 = require("./ReadingConfig");
Object.defineProperty(exports, "ReadingConfig", { enumerable: true, get: function () { return ReadingConfig_1.ReadingConfig; } });
const Reader_1 = require("./Reader");
Object.defineProperty(exports, "parseNumberData", { enumerable: true, get: function () { return Reader_1.parseNumberData; } });
Object.defineProperty(exports, "readNumber", { enumerable: true, get: function () { return Reader_1.readNumber; } });
//# sourceMappingURL=index.js.map